import { api } from '@/api/apiClient';
import { listOfflineItems, storeOfflineItem, removeOfflineItem } from '@/lib/offlineStore';

export const REPORT_KIND = 'equipment-report';
export const changed = () => window.dispatchEvent(new Event('equipment-reports-changed'));
export async function queueReport(payload) {
  const rows = await listOfflineItems(REPORT_KIND);
  if (rows.filter(row => !row.receipt).length >= 100) throw new Error('This device has 100 unsent reports. Connect to the internet to submit them first.');
  const owner = localStorage.getItem('sep-offline-owner');
  await storeOfflineItem({ key: `equipment:${payload.client_id}`, kind: REPORT_KIND, name: payload.asset_id, owner, payload });
  // Keep the most recent receipts available offline without retaining unlimited report history on the device.
  for (const row of rows.filter(row => row.receipt).sort((a, b) => b.saved_at.localeCompare(a.saved_at)).slice(49)) await removeOfflineItem(row.key);
  changed();
}
let pending;
export function syncEquipmentReports() {
  if (pending) return pending;
  pending = sync().finally(() => { pending = null; });
  return pending;
}
async function sync() {
  if (!navigator.onLine || localStorage.getItem('impersonate_user_id')) return;
  const owner = localStorage.getItem('sep-offline-owner');
  const token = localStorage.getItem('token');
  if (!owner || !token) return;
  const rows = await listOfflineItems(REPORT_KIND);
  for (const row of rows.filter(item => !item.receipt)) {
    if (owner !== localStorage.getItem('sep-offline-owner') || token !== localStorage.getItem('token')) return;
    try {
      api.token = token;
      const receipt = await api.request('POST', '/api/equipment-reports', row.payload, { 'X-SEP-Background': 'offline' });
      if (owner !== localStorage.getItem('sep-offline-owner') || !localStorage.getItem('token')) return;
      await storeOfflineItem({ ...row, receipt, sync_error: '' });
    } catch (error) {
      if (owner !== localStorage.getItem('sep-offline-owner') || !localStorage.getItem('token')) return;
      await storeOfflineItem({ ...row, sync_error: error.status === 400 ? error.message : 'Waiting for a connection and a valid sign-in. Your report is still on this device.' });
      if (error.status !== 400) break;
    }
  }
  changed();
}
